class ProductAccessories extends HTMLElement {
  constructor() {
    super();

    this.currentText = this.querySelector('.accessories-products__progress .current');
    this.needText = this.querySelector('.accessories-products__progress .need');
    this.maxCount = Number(this.dataset.fastShippingCount);
    this.accessories = this.querySelectorAll('product-info');
    this.currentVariant = JSON.parse(this.dataset.currentVariant);
    this.discountLabel = document.querySelector('.product-single__box__block--discount_label .save');

    // this.addSelectEventListeners();
    this.addQuantityEventListeners();

    this.addCheckboxListener();

    document.addEventListener('venue:variant:updated', this.updateVariantPrice);

    document.body.addEventListener('showCongratulationsPopup', () => {
      theme.mfpOpen('congratulations');
    });
  }

  addSelectEventListeners() {
    const containerSelect = this.querySelectorAll('.product-complementary__select');

    containerSelect.forEach((select) => {
      select.addEventListener('change', function (e) {
        const complementaryProductItem = e.currentTarget.closest('.complementary-products__item');
        const { price, comparedPrice } = e.currentTarget.options[select.selectedIndex].dataset;

        complementaryProductItem.querySelector('.product-complementary__price--original').innerHTML = price;
        complementaryProductItem.querySelector('.product-complementary__price--compared').innerHTML = comparedPrice;
      });
    });
  }

  changeProgressbar(increment) {
    const activeEl = this.querySelectorAll('.progressbar li.active');
    let currentNumber = Number(this.currentText.innerHTML);

    if (increment) {
      if (currentNumber < this.maxCount) {
        this.currentText.innerHTML = ++currentNumber;
        this.needText.innerHTML = this.maxCount - currentNumber;
      }
      this.querySelector('.progressbar li:not(.active)')?.classList.add('active');
    } else {
      if (currentNumber > 0) {
        this.currentText.innerHTML = --currentNumber;
        this.needText.innerHTML = this.maxCount - currentNumber;
      }
      activeEl[activeEl.length - 1]?.classList.remove('active');
    }

    this.dataset.showPopup = currentNumber == this.maxCount;
  }

  addQuantityEventListeners() {
    this.addEventListener('click', (e) => {
      if (e.target.type == 'button' && e.target.classList.contains('product-add__quantity-btn')) {
        this.onQuantityChange(e);
      }
    });
  }

  onQuantityChange(e) {
    const quantityInputEl = e.target
      .closest('.product-add__quantity-wrap')
      ?.querySelector('.product-add__quantity-input');
    let updatedQuantityValue = Number(quantityInputEl.value);

    if (e.target.classList.contains('decrease')) {
      updatedQuantityValue--;
    } else if (e.target.classList.contains('increase')) {
      updatedQuantityValue++;
    }

    if (updatedQuantityValue === 0) {
      const checkboxEl = e.target.closest('.product-add__checkbox-wrap')?.querySelector('.product-add__checkbox');

      if (checkboxEl) checkboxEl.checked = false;
    } else if (e.target != quantityInputEl) {
      quantityInputEl.value = updatedQuantityValue;
    }

    this.updateTotalPrice();
  }

  updateTotalPrice() {
    let totalPrice = 0;
    this.accessories.forEach((accessory) => {
      const quantityInput =
        accessory.querySelector(
          '.product-add__checkbox:checked~.product-add__quantity-wrap .product-add__quantity-input'
        )?.value || 0;
      totalPrice += Number(quantityInput) * accessory.dataset.price || 0;
    });

    this.dataset.totalPrice = totalPrice;
    this.updateVariantPrice();
  }

  updateVariantPrice(e) {
    if (e?.variant) {
      this.currentVariant = e.variant;
    }

    if (!this.currentVariant) return;

    const totalPrice = Number(this.dataset.totalPrice) || 0;

    const priceEls = document.querySelectorAll('.js-product-price-number .money .money');
    const compareAtPriceEls = document.querySelectorAll('.js-product-price-compare .money .money');

    priceEls.forEach((priceEl) => {
      priceEl.outerHTML = Shopify.formatMoney(this.currentVariant.price + totalPrice, theme.money_format);
    });

    compareAtPriceEls.forEach((compareAtPriceEl) => {
      compareAtPriceEl.outerHTML = Shopify.formatMoney(
        this.currentVariant.compare_at_price + totalPrice,
        theme.money_format
      );
    });

    this.discountLabel.innerHTML = Shopify.formatMoney(
      this.currentVariant.price * ((100 - this.discountLabel.dataset.percentage) / 100) + totalPrice,
      theme.money_format
    );
  }

  addCheckboxListener() {
    this.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-add__checkbox')) {
        this.updateTotalPrice();
        if (this.maxCount) {
          this.changeProgressbar(e.target.checked);
        }
      } else if (e.target.classList.contains('product-add__quantity-input')) {
        this.onQuantityChange(e);
      }
    });
  }
}
customElements.define('product-accessories', ProductAccessories);
